import { useMutation } from '@tanstack/react-query';

import { boxLifecycle } from '../../models/boxLifecycle';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

export interface IBulkUpdateLifecycleStatusRequest {
  lpUIList: string[];
  status: string;
  sub_status?: string;
  reason?: string;
  details?: string;
}

export interface IBulkUpdateLifecycleStatusError {
  lp_ui: string;
  error: string;
}

export interface IBulkUpdateLifecycleStatusResponse {
  lifecycle_statuses: boxLifecycle[];
  errors: IBulkUpdateLifecycleStatusError[];
}

const bulkUpdateLifecycleStatusFn =
  (
    makeRequest: (params: unknown) => Promise<{ data: unknown; error: unknown }>
  ) =>
  async (
    body: IBulkUpdateLifecycleStatusRequest
  ): Promise<IBulkUpdateLifecycleStatusResponse> => {
    const { data, error } = await makeRequest({
      path: '/products/lifecycle-status/bulk',
      method: 'post',
      body: {
        station_source: 'Admin Panel',
        ...body,
      },
    });

    if (!data || error) {
      throw new Error(
        typeof error === 'string' ? error : 'Bulk lifecycle update failed'
      );
    }

    return data as IBulkUpdateLifecycleStatusResponse;
  };

type UseBulkUpdateLifecycleStatusOptions = {
  config?: MutationConfig<ReturnType<typeof bulkUpdateLifecycleStatusFn>>;
};

export const useBulkUpdateLifecycleStatus = ({
  config,
}: UseBulkUpdateLifecycleStatusOptions = {}) => {
  const [, makeRequest] = useImperativeRequestWrapper('deviceV3');

  return useMutation({
    ...config,
    mutationFn: bulkUpdateLifecycleStatusFn(makeRequest),
  });
};
